/**
 *所有原生直接调H5的方法都封装在 window.__xgj__H5ToNative__callback__ 这个对象下
 *现在有如下方法：
 *clickBack => 点击返回键时调用
 *voicePlayEnd => 在原生语音播放完毕时调用
 *voiceRecordEnd => 在原生录音自动停止时调用
 */

import base from '@mlib/js/base/base.js';

let fnNames = [
  // 获取版本号
  'getAppVersion',
  // 检查更新
  'checkVersionUpdate',
  // 获取渠道信息字串
  'getChannelString',
  // "previewImages",
  "chooseImage",
  'chooseVideo',
  'downloadVideo',
  'startRecord',
  'stopRecord',
  'goBack',
  'setAppTitle',
  'showOptionMenu',
  'updateAppMessageShareData',
  'updateTimelineShareData',
  'openMiniProgram',
];

var xah = (window.xah = {});
var cb = {};

var e = new Vue();

window._xgj_ = window.xgjapp;
// window._xgj_ = window.xgj

window.__xgj__H5ToNative__callback__ = cb;

window.clickBack = cb.clickBack = function clickBack() {
  // Vue.event.$emit('appGoBack')
  e.$emit('appGoBack');
};

// Vue.event.$on('appGoBack', function () {
e.$on('appGoBack', function() {
  _xgj_.goBack();
});

// 提供给原生调用(在原生语音播放完毕时会调用)
cb.voicePlayEnd = function voicePlayEndHandler(res) {
  // alert('原生调用h5 => 语音播放完毕');
  cb.ovpeHandler && cb.ovpeHandler(res);
};
// 用于监听语音播放完毕, SDK提供给应用层调用
xah.onVoicePlayEnd = function(opt) {
  cb.ovpeHandler = opt.complete;
};

// 提供给原生调用(在原生录音自动停止时会调用)
cb.voiceRecordEnd = function voiceRecordEndHandler(res) {
  // alert('原生调用h5 => 录音自动停止');
  cb.vrHandler && cb.vrHandler(res);
};
// 用于监听录音自动停止, SDK提供给应用层调用
xah.onVoiceRecordEnd = function(opt) {
  cb.vrHandler = opt.complete;
};

// 云校APP上线 临时代码
if (base.env === 'xgj') {
  if (!window._xgj_) {
    window._xgj_ = {
      showOptionMenu: function() {},
      setAppTitle: function() {},
    };
  }
}
// 云校APP上线 临时代码

if (base.env === 'xgj') {
  const shareName = '__protocal' + Date.now() + '__';

  let idCount = 0;

  function createID() {
    return Date.now() + '$' + idCount++;
  }

  const send = (function() {
    let pool = {};

    window[shareName] = function exec(id) {
      let fn = pool[id];
      //delete pool[id];        //一次性.
      return fn;
    };

    return function(fn) {
      let id = createID();
      pool[id] = fn;
      return [`window.${shareName}('${id}')`, () => delete pool[id]]; //exec(id)(...)
    };
  })();

  const codeMap = {
    '0': 'success',
    '1': 'fail',
    '2': 'cancel',
    '3': 'progress', //查询进度
  };

  function wxApi(appRequest) {
    return function(opt) {
      let delFn = null; //回调函数清理

      function callback(res) {
        // if (!codeMap[res.code]){
        //     throw new Error('错误状态码:' + res.code);
        // }
        let fnName = codeMap[res.code + ''];
        opt[fnName] && opt[fnName](res.data);
        if (res.code != 3) {
          //如果是查询进度，不调用complete
          opt.complete && opt.complete(res);
          delFn();
        }
      }

      if (opt && typeof opt === 'object') {
        [opt.result, delFn] = send(callback);
        window._xgj_[appRequest](opt && JSON.stringify(opt));
      } else {
        window._xgj_[appRequest]();
      }
    };
  }

  fnNames.forEach(fnname => {
    if (base.isWKWebview === true) {
      if (typeof _xgj_ === 'undefined') {
        window._xgj_ = {};
      }
      Object.defineProperty(window._xgj_, fnname, {
        get: function() {
          return function(params) {
            // window.webkit.messageHandlers[fnname].postMessage(params);
            window.webkit.messageHandlers[`${fnname}_v1`].postMessage(params);
          };
        },
      });
    }

    xah[fnname] = wxApi(fnname);
  });
}

export default xah;
